export const CLEAR_CART = 'CLEAR_CART';

export const SET_CART = 'SET_CART';

export const UPDATE_CART = 'UPDATE_CART';

export const DEC_CART = 'DEC_CART';



// WEBPACK FOOTER //
// ./src/store/actions/types/cartActionTypes.js